export const testimonials = [  
  {  
    id: 1,  
    name: "María González",  
    rating: 5,  
    text: "¡Las tortas de GUILLOS Kitchen son increíbles! Pedí una para mi cumpleaños y todos quedaron fascinados. El sabor es divino y la entrega fue rapidísima.",  
    date: "Hace 2 días"  
  },  
  {  
    id: 2,  
    name: "Carlos Ruiz",  
    rating: 5,  
    text: "Excelente calidad en los dulces. Los macarons son mis favoritos, siempre frescos y con sabores únicos. Recomiendo 100% para eventos.",  
    date: "Hace 1 semana"  
  },  
  {  
    id: 3,  
    name: "Ana López",  
    rating: 4,  
    text: "Muy buena atención al cliente. Personalizaron mi pedido especial y quedó perfecto. Solo tardó un poquito más de lo esperado, pero valió la pena.",  
    date: "Hace 3 días"  
  },  
  {  
    id: 4,  
    name: "Juan Pérez",  
    rating: 5,  
    text: "El mejor lugar para comprar cupcakes en la ciudad. Envíos impecables y precios justos. ¡Volveré pronto por más delicias!",  
    date: "Hace 5 días"  
  },  
  {  
    id: 5,  
    name: "Laura Martínez",  
    rating: 5,  
    text: "Tortas artesanales de otro nivel. El cheesecake de frutos rojos es una explosión de sabor. Servicio 10/10, gracias GUILLOS Kitchen.",  
    date: "Hace 1 día"  
  }  
];